import APIConfig from '../apiconfig';

export const isSendGridApiUrl = (url: string | undefined) => {
  if (!url) {
    return false;
  }

  const allowedBaseUrls = [APIConfig.host, APIConfig.euHost];

  return allowedBaseUrls.some((baseUrl) => url.startsWith(baseUrl));
};
